module.exports = __webpack_public_path__ + "static/media/icon-live-stats-selected.b37c77cd.svg";